import styled from 'styled-components';

const TableHead = styled.thead`
  position: relative;
  width: 100%;
`;

export default TableHead;
